var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTwitter = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "twitter account connect") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.292969,
    width: 34,
    height: 34,
    rx: 17,
    fill: "#1F408C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.8409 11.1909C26.1171 11.5116 25.3396 11.7283 24.5222 11.8262C25.3656 11.3216 25.9965 10.5273 26.2974 9.5916C25.505 10.0623 24.6377 10.3936 23.7334 10.5711C23.1252 9.92174 22.3196 9.49133 21.4418 9.3467C20.564 9.20208 19.6629 9.35131 18.8786 9.77125C18.0942 10.1912 17.4705 10.8583 17.1041 11.6691C16.7378 12.4798 16.6494 13.3889 16.8526 14.255C15.247 14.1744 13.6763 13.7571 12.2424 13.0301C10.8086 12.3032 9.54357 11.2829 8.52954 10.0354C8.18282 10.6335 7.98345 11.327 7.98345 12.0655C7.98307 12.7303 8.14679 13.385 8.46009 13.9713C8.7734 14.5577 9.2266 15.0577 9.77948 15.427C9.13828 15.4066 8.51123 15.2333 7.95051 14.9216V14.9736C7.95045 15.9061 8.273 16.8098 8.86342 17.5316C9.45385 18.2533 10.2758 18.7485 11.1898 18.9332C10.595 19.0942 9.97134 19.1179 9.36601 19.0025C9.62389 19.8049 10.1262 20.5065 10.8026 21.0091C11.4791 21.5118 12.2958 21.7903 13.1384 21.8058C11.708 22.9287 9.94148 23.5378 8.12301 23.5351C7.80089 23.5352 7.47904 23.5164 7.15912 23.4787C9.00497 24.6655 11.1537 25.2954 13.3481 25.293C20.7767 25.293 24.8377 19.1404 24.8377 13.8043C24.8377 13.6309 24.8333 13.4558 24.8255 13.2825C25.6155 12.7112 26.2973 12.0038 26.8391 11.1935L26.8409 11.1909Z",
    fill: "#4987FF"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTwitter);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/twitter.6b45b66780906dcbd9fa269c4f99ea69.svg";